module.exports = "../fonts/icon-attach.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-attach.svg
// module id = 426
// module chunks = 0